import { createStore } from "vuex";
import auth from "./auth";
import theme from "./theme";
import salary from "./salary";
import notification from "./notification";
import app from "./app";
import system from "./system";
import geofence from "./geofence";

export default createStore({
  modules: {
    auth,
    theme,
    salary,
    notification,
    app,
    system,
    geofence,
  },
});
